import { render, staticRenderFns } from "./introduce.vue?vue&type=template&id=186ad9b0&scoped=true&"
import script from "./introduce.vue?vue&type=script&lang=js&"
export * from "./introduce.vue?vue&type=script&lang=js&"
import style0 from "./introduce.vue?vue&type=style&index=0&id=186ad9b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186ad9b0",
  null
  
)

export default component.exports